import { BaseResponse } from '../../../../../../types/api/api.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { ProfilePasswordFormSchema } from './ProfilePasswordForm.types';

const PREFIX = '[updateUserPasswordQuery]';

export const UPDATE_USER_PASSWORD_QUERY_KEY = 'UPDATE_USER_PASSWORD';

export const updateUserPasswordQuery = async (data: ProfilePasswordFormSchema) => {
  console.log(PREFIX, `Requesting user password update...`);
  const response = await AUTH_ENDPOINTS.updateUserPassword(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user password update response.`);
  return json as BaseResponse;
};
